module.exports = __webpack_public_path__ + "img/money_1.af244dc6.svg";